import { Check, Minus } from "lucide-react";
import { PLANS } from "@/lib/plans";
import { cn } from "@/lib/utils";

/** The three plans side by side. `action(plan)` renders each card's button; `current` marks the plan you're on. */
export const PlanCards = ({ action, current, large = false, testid = "plan-cards" }) => (
  <div className="grid gap-4 md:grid-cols-3" data-testid={testid}>
    {PLANS.map((plan) => {
      const isCurrent = plan.id === current;
      return (
        <div key={plan.id} data-testid={`plan-${plan.id}`}
          className={cn("flex flex-col rounded-2xl border bg-background", large ? "p-7 md:p-8" : "p-5",
            isCurrent && "border-foreground/40 ring-1 ring-foreground/40")}>
          <div className="flex items-center justify-between gap-2">
            <h3 className={cn("font-semibold", large ? "text-lg" : "text-base")}>{plan.name}</h3>
            {isCurrent && <span className="rounded-full bg-muted px-2 py-0.5 text-xs font-medium" data-testid={`plan-${plan.id}-current`}>Your plan</span>}
          </div>
          <p className="mt-1 text-sm text-muted-foreground">For agencies letting about {plan.fits}</p>
          <p className={cn("flex items-baseline gap-1.5", large ? "mt-8" : "mt-5")}>
            <span className={cn("font-semibold tracking-tight", large ? "text-[44px] leading-none" : "text-3xl")}>{plan.price}</span>
            <span className="text-sm text-muted-foreground">{plan.unit}</span>
          </p>
          <p className="mt-2 text-sm text-muted-foreground">{plan.note}</p>
          <ul className={cn("flex flex-1 flex-col gap-2.5 border-t", large ? "mt-8 pt-6" : "mt-5 pt-4")}>
            {plan.features.map((f) => (
              <li key={f.text} className={cn("flex items-start gap-2.5 text-sm", !f.included && "text-muted-foreground")}>
                {f.included
                  ? <Check className="mt-0.5 size-4 shrink-0 text-success" strokeWidth={2.5} aria-label="Included" />
                  : <Minus className="mt-0.5 size-4 shrink-0 text-muted-foreground/60" aria-label="Not included" />}
                {f.text}
              </li>
            ))}
          </ul>
          <div className={large ? "mt-8" : "mt-6"}>{action(plan, isCurrent)}</div>
        </div>
      );
    })}
  </div>
);
